import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  // Card,
  // CardContent,
  Typography,
  TextField,
  Button,
  Stack,
  Grid,
  alpha,
  IconButton,
  Avatar,
  Paper,
  // Divider,
  Chip,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  // Switch,
  // FormControlLabel,
  InputAdornment,
  // LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  // ListItemAvatar,
  CircularProgress,
  Alert,
  // Tooltip,
} from "@mui/material";
import {
  Edit,
  Save,
  Cancel,
  Person,
  Store,
  Phone,
  Email,
  LocationOn,
  AccountBalance,
  // Security,
  // Cloud,
  // QrCode,
  Analytics,
  // Receipt,
  // Inventory,
  CreditCard,
  // Password,
  Visibility,
  VisibilityOff,
  CalendarToday,
  Business,
  Verified,
  // Backup,
  // Language,
  // Notifications,
  // DarkMode,
  // LightMode,
  // Download,
  // Upload,
  // Delete,
  // Refresh,
  // MoreVert,
  Lock,
  LockOpen,
  CheckCircle,
  CurrencyRupee,
  // Warning,
  // Info,
  // Add missing imports
  // AttachMoney,
  // Settings,
  // Devices,
  // History,
  // AccessTime,
} from "@mui/icons-material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import { DataContext } from "../context/DataContext";
import { sessionManager } from "../context/sessionManager";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import GetAppIcon from "@mui/icons-material/GetApp";

// Tab Panel Component
const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`profile-tabpanel-${index}`}
    aria-labelledby={`profile-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
  </div>
);

// Profile Page Component
const Profile = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [activeTab, setActiveTab] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordDialog, setPasswordDialog] = useState(false);
  // const [backupDialog, setBackupDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [exporting, setExporting] = useState(false);
const [exportMessage, setExportMessage] = useState("");
  // const { companyDetails } = React.useContext(DataContext);
  const {
    companyDetails,
    customers,
    customerTransactions,
    girvi,
    girviPayments,
    roznama,
    schemeCard,
    silverStock,
    silverTransactions,
    stock,
    suppliers,
    supplierTransactions
  } = React.useContext(DataContext);

  // Mock user data (in real app, this would come from context/API)
  // const [userData, setUserData] = useState({
  //   shopName: "JewelStock Pro Demo",
  //   ownerName: "Darshan Jain",
  //   phone: "9876543210",
  //   email: "demo@jewelstockpro.com",
  //   address: "123 Jewelry Street, Business District, City - 400001",
  //   gstNumber: "22AAAAA0000A1Z5",
  //   // Bank Details
  //   bankName: "State Bank of India",
  //   accountHolderName: "Darshan Jain",
  //   accountNumber: "123456789012",
  //   ifscCode: "SBIN0001234",
  //   branchName: "Main Branch, City",
  //   // Subscription
  //   subscription: {
  //     plan: "Pro",
  //     status: "active",
  //     expiryDate: "2027-01-01",
  //     autoRenew: true,
  //     paymentMethod: "Credit Card",
  //   },
  //   // Settings
  //   settings: {
  //     darkMode: isDark,
  //     notifications: true,
  //     autoBackup: true,
  //     backupFrequency: "daily",
  //     language: "English",
  //     timezone: "IST",
  //   },
  //   // Stats
  //   stats: {
  //     totalCustomers: 1250,
  //     totalInvoices: 4520,
  //     totalRevenue: "₹52,80,450",
  //     activeProducts: 325,
  //     storageUsed: "65%",
  //     lastBackup: "2026-01-15 14:30",
  //   },
  // });
  const [userData, setUserData] = useState({});

  useEffect(() => {
    // Initialize dark mode based on system preference or saved setting
    const user = sessionManager.getUser();
    setUserData(user);
    console.log(user);
    setUserData(companyDetails.find(cd => cd.id === user.id) || user);
    console.log("Company Details in Profile:", companyDetails);
  }, [companyDetails]);

  // Validation Schema for Edit Mode
  const validationSchema = Yup.object({
    shopName: Yup.string()
      .required("Shop name is required")
      .min(3, "Shop name must be at least 3 characters"),
    ownerName: Yup.string()
      .required("Owner name is required")
      .min(2, "Owner name must be at least 2 characters"),
    phone: Yup.string()
      .required("Phone number is required")
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email address"),
    address: Yup.string()
      .required("Address is required")
      .min(10, "Address must be at least 10 characters"),
    gstNumber: Yup.string()
      .matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        "Invalid GST number format"
      )
      .nullable(),
    bankName: Yup.string().nullable(),
    accountHolderName: Yup.string().nullable(),
    accountNumber: Yup.string()
      .matches(/^[0-9]{9,18}$/, "Invalid bank account number")
      .nullable(),
    ifscCode: Yup.string()
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code")
      .nullable(),
    branchName: Yup.string().nullable(),
  });

  // Password Change Schema
  const passwordSchema = Yup.object({
    currentPassword: Yup.string().required("Current password is required"),
    newPassword: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Must contain at least one uppercase letter")
      .matches(/[a-z]/, "Must contain at least one lowercase letter")
      .matches(/[0-9]/, "Must contain at least one number")
      .matches(/[^A-Za-z0-9]/, "Must contain at least one special character"),
    confirmPassword: Yup.string()
      .required("Please confirm your password")
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
  });


  const exportToExcel = (data) => {
    try {
      // Create a new workbook
      const wb = XLSX.utils.book_new();
      console.log("Exporting data to Excel:", data);
      // Define sheet configurations with their respective data and columns
      const sheetConfigs = [
        {
          name: 'CompanyDetails',
          data: data.CompanyDetails || [],
          columns: ['id', 'shopName', 'ownerName', 'phone', 'email', 'address', 'gstNumber', 'bankName', 'accountHolderName', 'accountNumber',	'ifscCode',	'branchName',	'password',	'acceptTerms',	'startDate',	'endDate',	'softwareCost',	'amc', 'createdAt', 'updatedAt']
        },
        {
          name: 'CustomerTransactions',
          data: data.CustomerTransactions || [],
          columns: ['id', 'customer', 'date', 'items', 'calculatedTotals', 'paymentDetails', 'summary', 'transactionDetails', 'metaDetails', 'createdAt', 'updatedAt']
        },
        {
          name: 'Customers',
          data: data.Customers || [],
          columns: ['id', 'name', 'contact', 'address', 'emailId', 'dob', 'anniversary', 'familyMembers', 'openingBalance', 'currentBalance', 'dateAdded', 'createdAt', 'updatedAt']
        },
        {
          name: 'Girvi',
          data: data.Girvi || [],
          columns: ['id', 'customerName', 'mobileNo', 'itemName', 'itemWeight', 'principal', 'interestRate', 'startDate', 'interestTillDate', 'interestAmount',	'totalPayable',	'initialPrincipal', 'createdAt', 'updatedAt']
        },
        {
          name: 'GirviPayments',
          data: data.GirviPayments || [],
          columns: ['id', 'girviId', 'date', 'paymentAmount', 'type', 'remainingPrincipal', 'interestEarned', 'createdAt', 'updatedAt']
        },
        {
          name: 'Roznama',
          data: data.Roznama || [],
          columns: ['id', 'date', 'openingBalanceCash', 'openingBalanceBank', 'closingBalanceCash', 'closingBalanceBank', 'incomeTransactions', 'expenseTransactions', 'netProfit', 'totalIncome', 'totalExpense', 'createdAt', 'updatedAt']
        },
        {
          name: 'SchemeCard',
          data: data.SchemeCard || [],
          columns: ['id', 'customerId', 'monthlyAmount', 'totalDeposited', 'monthsCompleted', 'startDate', 'endDate', 'cardIssued', 'cardLostFee', 'status', 'bonus', 'months', 'createdAt', 'updatedAt']
        },
        {
          name: 'SilverStock',
          data: data.SilverStock ? [data.SilverStock] : [],
          columns: ['999silver', '925silver', 'mixsilver', 'silver', 'oldsilver', 'gold']
        },
        {
          name: 'SilverTransaction',
          data: data.SilverTransaction || [],
          columns: ['id', 'date', 'silverTransaction']
        },
        {
          name: 'Stock',
          data: data.Stock || [],
          columns: ['id', 'qr', 'name', 'weight', 'grossWeight', 'lessWeight', 'silverRate', 'labour', 'goldCuttingRate', 'wastage', 'supplierName', 'supplierShortcut', 'serialNo', 'metal', 'melting', 'makingCharges', 'huid', 'sold', 'soldDescription', 'description', 'itemDetail', 'price', 'miscitemName', 'miscitemShortcut', 'createdAt', 'updatedAt']
        },
        {
          name: 'Suppliers',
          data: data.Suppliers || [],
          columns: ['id', 'name', 'contact', 'email', 'gstNumber', 'openingBalanceCash', 'openingBalanceBank', 'openingBalanceFine', 'balanceValueCash', 'balanceValueBank', 'balanceFine', 'address', 'bankName', 'accountHolder', 'accountNumber', 'ifscCode', 'branch', 'dateAdded', 'createdAt', 'updatedAt']
        },
        {
          name: 'SupplierTransactions',
          data: data.SupplierTransactions || [],
          columns: ['id', 'supplier', 'date', 'items', 'gstApplicable', 'payments', 'finePayments', 'discount', 'summary', 'createdAt', 'updatedAt']
        }
      ];
  
      // Process each sheet configuration
      sheetConfigs.forEach(config => {
        if (config.data && config.data.length > 0) {
          // Convert data to worksheet format
          const worksheetData = config.data.map(item => {
            const row = {};
            config.columns.forEach(column => {
              // Handle nested objects (convert to JSON string)
              if (item[column] && typeof item[column] === 'object') {
                row[column] = JSON.stringify(item[column]);
              } else {
                row[column] = item[column] !== undefined ? item[column] : '';
              }
            });
            return row;
          });
  
          // Create worksheet
          const ws = XLSX.utils.json_to_sheet(worksheetData);
  
          // Auto-size columns (optional)
          const colWidths = [];
          config.columns.forEach(col => {
            const maxLength = Math.max(
              col.length,
              ...worksheetData.map(row => String(row[col] || '').length)
            );
            colWidths.push({ wch: Math.min(maxLength + 2, 50) }); // Cap at 50 characters
          });
          ws['!cols'] = colWidths;
  
          // Add worksheet to workbook
          XLSX.utils.book_append_sheet(wb, ws, config.name);
        } else {
          // Create empty sheet with just headers
          const ws = XLSX.utils.json_to_sheet([]);
          XLSX.utils.sheet_add_aoa(ws, [config.columns]);
          XLSX.utils.book_append_sheet(wb, ws, config.name);
        }
      });
  
      // Generate Excel file
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
  
      // Generate filename with current date
      const date = new Date();
      const dateStr = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
      const filename = `JewelStock_Export_${dateStr}.xlsx`;
  
      // Save file
      saveAs(blob, filename);
  
      return { success: true, message: 'Excel file exported successfully!' };
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      return { success: false, message: error.message };
    }
  };

  const handleExport = () => {
    setExporting(true);
  
    const exportData = {
      CompanyDetails: companyDetails,
      CustomerTransactions: customerTransactions,
      Customers: customers,
      Girvi: girvi,
      GirviPayments: girviPayments,
      Roznama: roznama,
      SchemeCard: schemeCard,
      SilverStock: silverStock,
      SilverTransaction: silverTransactions,
      Stock: stock,
      Suppliers: suppliers,
      SupplierTransactions: supplierTransactions
    };
  
    const result = exportToExcel(exportData);
  
    if (result.success) {
      setExportMessage("Backup exported successfully!");
    } else {
      setExportMessage("Export failed!");
    }
  
    setExporting(false);
  };

  // Handle Form Submission
  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      setUserData(prev => ({ ...prev, ...values }));
      setSuccessMessage("Profile updated successfully!");
      setEditMode(false);

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Password Change
  const handlePasswordChange = async (values) => {
    setIsLoading(true);
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      setSuccessMessage("Password changed successfully!");
      setPasswordDialog(false);

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      console.error("Password change failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Backup
  // const handleBackup = async () => {
  //   setIsLoading(true);
  //   try {
  //     // Simulate backup process
  //     await new Promise(resolve => setTimeout(resolve, 2000));
  //     setSuccessMessage("Backup created successfully!");
  //     // setBackupDialog(false);

  //     setTimeout(() => {
  //       setSuccessMessage("");
  //     }, 3000);
  //   } catch (error) {
  //     console.error("Backup failed:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // Custom Styled Field Component
  const StyledField = ({
    field,
    form,
    meta,
    label,
    placeholder,
    type = "text",
    InputProps,
    disabled = false,
    ...props
  }) => (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          mb: 1,
          fontWeight: 600,
          color: isDark ? "#cbd5e1" : "#475569",
          fontSize: "0.9rem",
        }}
      >
        {label}
      </Typography>
      <TextField
        {...field}
        fullWidth
        type={type}
        placeholder={placeholder}
        error={meta.touched && !!meta.error}
        helperText={meta.touched && meta.error}
        disabled={disabled}
        InputProps={InputProps}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: isDark
              ? alpha("#1e293b", 0.5)
              : alpha("#ffffff", 0.9),
            backdropFilter: "blur(10px)",
            border: `1.5px solid ${alpha(
              isDark ? "#475569" : "#e2e8f0",
              isDark ? 0.3 : 0.4
            )}`,
            transition: "all 0.2s ease",
            "&:hover": {
              borderColor: alpha(
                isDark ? "#60a5fa" : "#2563eb",
                isDark ? 0.5 : 0.4
              ),
            },
            "&.Mui-focused": {
              borderColor: isDark ? "#60a5fa" : "#2563eb",
              borderWidth: "2px",
              backgroundColor: isDark
                ? alpha("#1e293b", 0.7)
                : alpha("#ffffff", 0.95),
            },
            "&.Mui-disabled": {
              backgroundColor: isDark
                ? alpha("#1e293b", 0.3)
                : alpha("#f8fafc", 0.8),
            },
          },
          "& .MuiOutlinedInput-input": {
            color: isDark ? "#f1f5f9" : "#1e293b",
            fontSize: "0.95rem",
            padding: "12px 16px",
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            fontSize: "0.8rem",
          },
        }}
        {...props}
      />
    </Box>
  );

  // Profile Header Component
  const ProfileHeader = () => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 3,
        mb: 4,
        p: 3,
        borderRadius: "20px",
        background: isDark
          ? "linear-gradient(90deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)"
          : "linear-gradient(90deg, rgba(37, 99, 235, 0.08) 0%, rgba(29, 78, 216, 0.04) 100%)",
        border: `1px solid ${alpha(
          isDark ? "#475569" : "#e2e8f0",
          isDark ? 0.2 : 0.3
        )}`,
      }}
    >
      <Avatar
        sx={{
          width: 100,
          height: 100,
          fontSize: 40,
          background: isDark
            ? "linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)"
            : "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
          boxShadow: isDark
            ? "0 8px 32px rgba(96, 165, 250, 0.3)"
            : "0 8px 32px rgba(37, 99, 235, 0.3)",
          border: `3px solid ${alpha(
            isDark ? "#60a5fa" : "#2563eb",
            isDark ? 0.3 : 0.2
          )}`,
        }}
      >
        {userData?.shopName?.charAt(0)}
      </Avatar>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: isDark ? "#f1f5f9" : "#1e293b",
            mb: 1,
          }}
        >
          {userData?.shopName}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: isDark ? "#94a3b8" : "#64748b",
            mb: 2,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Person sx={{ fontSize: 20 }} />
          {userData?.ownerName}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Chip
            icon={<Store />}
            label="Jewellery Business"
            sx={{
              background: isDark
                ? "linear-gradient(135deg, rgba(96, 165, 250, 0.15) 0%, rgba(59, 130, 246, 0.15) 100%)"
                : "linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(29, 78, 216, 0.15) 100%)",
              color: isDark ? "#60a5fa" : "#2563eb",
              border: `1px solid ${alpha(
                isDark ? "#60a5fa" : "#2563eb",
                isDark ? 0.3 : 0.2
              )}`,
            }}
          />
          <Chip
            icon={<Verified />}
            label={`${userData?.softwareCost?.plan || "Pro"} Plan`}
            sx={{
              background: isDark
                ? "linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(5, 150, 105, 0.15) 100%)"
                : "linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(5, 150, 105, 0.15) 100%)",
              color: isDark ? "#10b981" : "#10b981",
              border: `1px solid ${alpha(
                isDark ? "#10b981" : "#10b981",
                isDark ? 0.3 : 0.2
              )}`,
            }}
          />
          {/* <Chip
            icon={<CheckCircle />}
            label="Active"
            sx={{
              background: isDark
                ? "linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(21, 128, 61, 0.15) 100%)"
                : "linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(21, 128, 61, 0.15) 100%)",
              color: isDark ? "#22c55e" : "#22c55e",
              border: `1px solid ${alpha(
                isDark ? "#22c55e" : "#22c55e",
                isDark ? 0.3 : 0.2
              )}`,
            }}
          /> */}
        </Box>
      </Box>
      {/* <Box>
        <Button
          variant="contained"
          startIcon={editMode ? <Save /> : <Edit />}
          onClick={() => setEditMode(!editMode)}
          disabled={isLoading}
          sx={{
            borderRadius: "12px",
            fontWeight: 600,
            px: 4,
            py: 1.5,
            background: isDark
              ? "linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)"
              : "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
            boxShadow: isDark
              ? "0 8px 25px rgba(96, 165, 250, 0.3)"
              : "0 8px 25px rgba(37, 99, 235, 0.3)",
          }}
        >
          {editMode ? "Save Changes" : "Edit Profile"}
        </Button>
      </Box> */}
    </Box>
  );

  // Statistics Cards
  // const StatCard = ({ icon, title, value, color }) => (
  //   <Paper
  //     sx={{
  //       p: 3,
  //       borderRadius: "16px",
  //       background: isDark
  //         ? alpha("#1e293b", 0.5)
  //         : alpha("#ffffff", 0.9),
  //       backdropFilter: "blur(10px)",
  //       border: `1px solid ${alpha(
  //         isDark ? "#475569" : "#e2e8f0",
  //         isDark ? 0.2 : 0.3
  //       )}`,
  //       height: "100%",
  //       transition: "all 0.3s ease",
  //       "&:hover": {
  //         transform: "translateY(-4px)",
  //         boxShadow: isDark
  //           ? "0 12px 40px rgba(0, 0, 0, 0.3)"
  //           : "0 12px 40px rgba(30, 41, 59, 0.15)",
  //       },
  //     }}
  //   >
  //     <Box
  //       sx={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "space-between",
  //         mb: 2,
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           width: 48,
  //           height: 48,
  //           borderRadius: "12px",
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           background: isDark
  //             ? alpha(color, 0.2)
  //             : alpha(color, 0.1),
  //           border: `1.5px solid ${alpha(color, 0.3)}`,
  //         }}
  //       >
  //         {React.cloneElement(icon, {
  //           sx: { fontSize: 24, color: color },
  //         })}
  //       </Box>
  //     </Box>
  //     <Typography
  //       variant="h3"
  //       sx={{
  //         fontWeight: 700,
  //         color: isDark ? "#f1f5f9" : "#1e293b",
  //         mb: 1,
  //       }}
  //     >
  //       {value}
  //     </Typography>
  //     <Typography
  //       variant="body2"
  //       sx={{
  //         color: isDark ? "#94a3b8" : "#64748b",
  //         fontWeight: 500,
  //       }}
  //     >
  //       {title}
  //     </Typography>
  //   </Paper>
  // );

  // Info Item Component
  const InfoItem = ({ icon, label, value, action }) => (
    <ListItem
      sx={{
        px: 0,
        py: 2,
        borderBottom: `1px solid ${alpha(
          isDark ? "#475569" : "#e2e8f0",
          isDark ? 0.2 : 0.3
        )}`,
      }}
    >
      <ListItemIcon sx={{ minWidth: 40 }}>
        {React.cloneElement(icon, {
          sx: { color: isDark ? "#60a5fa" : "#2563eb" },
        })}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography
            variant="body1"
            sx={{
              fontWeight: 600,
              color: isDark ? "#f1f5f9" : "#1e293b",
            }}
          >
            {label}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              color: isDark ? "#94a3b8" : "#64748b",
              mt: 0.5,
            }}
          >
            {value}
          </Typography>
        }
      />
      {action && (
        <ListItemIcon sx={{ minWidth: "auto" }}>
          {action}
        </ListItemIcon>
      )}
    </ListItem>
  );

  // Password Change Dialog
  const PasswordChangeDialog = () => (
    <Dialog
      open={passwordDialog}
      onClose={() => setPasswordDialog(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: isDark
            ? "linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%)"
            : "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)",
          backdropFilter: "blur(30px)",
          border: `1px solid ${alpha(
            isDark ? "#475569" : "#e2e8f0",
            isDark ? 0.2 : 0.3
          )}`,
          boxShadow: isDark
            ? "0 20px 60px rgba(0, 0, 0, 0.4)"
            : "0 20px 60px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: 3,
          background: isDark
            ? "linear-gradient(90deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)"
            : "linear-gradient(90deg, rgba(37, 99, 235, 0.08) 0%, rgba(29, 78, 216, 0.04) 100%)",
          borderBottom: `1px solid ${alpha(
            isDark ? "#475569" : "#e2e8f0",
            isDark ? 0.2 : 0.3
          )}`,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            background: isDark
              ? "linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)"
              : "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Lock />
          Change Password
        </Typography>
      </DialogTitle>
      <Formik
        initialValues={{
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        validationSchema={passwordSchema}
        onSubmit={handlePasswordChange}
      >
        {({ values, errors, touched }) => (
          <Form>
            <DialogContent sx={{ p: 3 }}>
              <Stack spacing={3}>
                <Field name="currentPassword">
                  {({ field, form, meta }) => (
                    <StyledField
                      field={field}
                      form={form}
                      meta={meta}
                      label="Current Password"
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Lock
                              sx={{
                                color: isDark ? "#60a5fa" : "#2563eb",
                              }}
                            />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                              sx={{
                                color: isDark ? "#94a3b8" : "#64748b",
                              }}
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </Field>

                <Field name="newPassword">
                  {({ field, form, meta }) => (
                    <StyledField
                      field={field}
                      form={form}
                      meta={meta}
                      label="New Password"
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockOpen
                              sx={{
                                color: isDark ? "#60a5fa" : "#2563eb",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </Field>

                <Field name="confirmPassword">
                  {({ field, form, meta }) => (
                    <StyledField
                      field={field}
                      form={form}
                      meta={meta}
                      label="Confirm New Password"
                      type={showPassword ? "text" : "password"}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CheckCircle
                              sx={{
                                color: isDark ? "#60a5fa" : "#2563eb",
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </Field>
              </Stack>
            </DialogContent>
            <DialogActions
              sx={{
                p: 3,
                borderTop: `1px solid ${alpha(
                  isDark ? "#475569" : "#e2e8f0",
                  isDark ? 0.2 : 0.3
                )}`,
              }}
            >
              <Button
                onClick={() => setPasswordDialog(false)}
                variant="outlined"
                sx={{ borderRadius: "12px" }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={isLoading}
                sx={{
                  borderRadius: "12px",
                  fontWeight: 600,
                  px: 4,
                }}
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Change Password"
                )}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: 4,
        px: 2,
        background: isDark
          ? "linear-gradient(156.2deg, rgb(1, 1, 1) 14.8%, rgba(32,104,177,1) 68.1%, rgb(169, 192, 218) 129%)"
          : 'radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(148, 187, 233, 1) 100%)',
        backgroundAttachment: "fixed",
      }}
    >
      {/* Success Message */}
      {successMessage && (
        <Alert
          severity="success"
          sx={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 9999,
            borderRadius: "12px",
            backdropFilter: "blur(10px)",
            boxShadow: "0 8px 32px rgba(16, 185, 129, 0.2)",
            minWidth: 300,
          }}
          onClose={() => setSuccessMessage("")}
        >
          {successMessage}
        </Alert>
      )}

      <PasswordChangeDialog />

      <Container maxWidth="lg">
        <ProfileHeader />

        {/* Statistics Cards
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<Person />}
              title="Total Customers"
              value={userData.stats.totalCustomers}
              color={isDark ? "#60a5fa" : "#2563eb"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<Receipt />}
              title="Total Invoices"
              value={userData.stats.totalInvoices}
              color={isDark ? "#10b981" : "#10b981"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<AttachMoney />}
              title="Total Revenue"
              value={userData.stats.totalRevenue}
              color={isDark ? "#f59e0b" : "#f59e0b"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <StatCard
              icon={<Inventory />}
              title="Active Products"
              value={userData.stats.activeProducts}
              color={isDark ? "#8b5cf6" : "#8b5cf6"}
            />
          </Grid>
        </Grid> */}

        {/* Tabs */}
        <Paper
          sx={{
            p: 2,
            borderRadius: "20px",
            background: isDark
              ? "linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.8) 100%)"
              : "linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(248, 250, 252, 0.8) 100%)",
            backdropFilter: "blur(20px)",
            border: `1px solid ${alpha(
              isDark ? "#475569" : "#e2e8f0",
              isDark ? 0.2 : 0.3
            )}`,
            boxShadow: isDark
              ? "0 20px 60px rgba(0, 0, 0, 0.3)"
              : "0 20px 60px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: alpha(
                isDark ? "#475569" : "#e2e8f0",
                isDark ? 0.2 : 0.3
              ),
            }}
          >
            <Tabs
              value={activeTab}
              onChange={(e, newValue) => setActiveTab(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTab-root": {
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: "1rem",
                  minHeight: 60,
                  color: isDark ? "#94a3b8" : "#64748b",
                  "&.Mui-selected": {
                    color: isDark ? "#60a5fa" : "#2563eb",
                  },
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: isDark ? "#60a5fa" : "#2563eb",
                  height: 3,
                  borderRadius: "3px",
                },
              }}
            >
              <Tab icon={<Person />} iconPosition="start" label="Profile" />
              <Tab icon={<Business />} iconPosition="start" label="Business" />
              <Tab icon={<AccountBalance />} iconPosition="start" label="Bank" />
              <Tab icon={<CreditCard />} iconPosition="start" label="Subscription" />
              <Tab icon={<Analytics />} iconPosition="start" label="Settings" />
              {/* <Tab icon={<Security />} iconPosition="start" label="Security" /> */}
              {/* <Tab icon={<Settings />} iconPosition="start" label="Settings" /> */}
            </Tabs>
          </Box>

          {/* Profile Tab */}
          <TabPanel value={activeTab} index={0}>
            <Formik
              initialValues={userData}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values, errors, touched, handleSubmit: formikSubmit }) => (
                <Form>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Field name="shopName">
                        {({ field, form, meta }) => (
                          <StyledField
                            field={field}
                            form={form}
                            meta={meta}
                            label="Shop/Business Name"
                            placeholder="Enter your shop name"
                            disabled={!editMode}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Store
                                    sx={{
                                      color: isDark ? "#60a5fa" : "#2563eb",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Field name="ownerName">
                        {({ field, form, meta }) => (
                          <StyledField
                            field={field}
                            form={form}
                            meta={meta}
                            label="Owner Name"
                            placeholder="Enter owner's full name"
                            disabled={!editMode}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Person
                                    sx={{
                                      color: isDark ? "#60a5fa" : "#2563eb",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Field name="phone">
                        {({ field, form, meta }) => (
                          <StyledField
                            field={field}
                            form={form}
                            meta={meta}
                            label="Phone Number"
                            placeholder="10-digit mobile number"
                            type="tel"
                            disabled={!editMode}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Phone
                                    sx={{
                                      color: isDark ? "#60a5fa" : "#2563eb",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Field name="email">
                        {({ field, form, meta }) => (
                          <StyledField
                            field={field}
                            form={form}
                            meta={meta}
                            label="Email Address"
                            placeholder="business@example.com"
                            type="email"
                            disabled={!editMode}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Email
                                    sx={{
                                      color: isDark ? "#60a5fa" : "#2563eb",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </Grid>

                    {/* Add Address Field */}
                    <Grid item xs={12}>
                      <Field name="address">
                        {({ field, form, meta }) => (
                          <StyledField
                            field={field}
                            form={form}
                            meta={meta}
                            label="Business Address"
                            placeholder="Full address with city, state, and pin code"
                            multiline
                            rows={2}
                            disabled={!editMode}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <LocationOn
                                    sx={{
                                      color: isDark ? "#60a5fa" : "#2563eb",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Field>
                    </Grid>

                    {/* Add GST Field */}
                    <Grid item xs={12} md={6}>
                      <Field name="gstNumber">
                        {({ field, form, meta }) => (
                          <StyledField
                            field={field}
                            form={form}
                            meta={meta}
                            label="GST Number (Optional)"
                            placeholder="22AAAAA0000A1Z5"
                            disabled={!editMode}
                          />
                        )}
                      </Field>
                    </Grid>

                    {editMode && (
                      <Grid item xs={12}>
                        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                          <Button
                            variant="outlined"
                            startIcon={<Cancel />}
                            onClick={() => setEditMode(false)}
                            sx={{ borderRadius: "12px" }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            variant="contained"
                            startIcon={<Save />}
                            onClick={formikSubmit}  // Use formikSubmit instead of handleSubmit
                            disabled={isLoading}
                            sx={{
                              borderRadius: "12px",
                              fontWeight: 600,
                              px: 4,
                              background: isDark
                                ? "linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)"
                                : "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
                            }}
                          >
                            {isLoading ? (
                              <CircularProgress size={24} sx={{ color: "#fff" }} />
                            ) : (
                              "Save Changes"
                            )}
                          </Button>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Form>
              )}
            </Formik>
          </TabPanel>

          {/* Business Tab */}
          <TabPanel value={activeTab} index={1}>
            <List>
              <InfoItem
                icon={<Store />}
                label="Business Type"
                value="Jewellery Retail"
              />
              <InfoItem
                icon={<LocationOn />}
                label="Business Address"
                value={userData?.address}
                action={
                  editMode && (
                    <IconButton size="small">
                      <Edit />
                    </IconButton>
                  )
                }
              />
              <InfoItem
                icon={<Business />}
                label="GST Number"
                value={userData?.gstNumber || "Not provided"}
                action={
                  editMode && (
                    <IconButton size="small">
                      <Edit />
                    </IconButton>
                  )
                }
              />
              {/* <InfoItem
                icon={<CalendarToday />}
                label="Business Since"
                value="January 2026"
              /> */}
              <InfoItem
                icon={<Analytics />}
                label="Business Category"
                value="Retail Jewellery"
              />
            </List>
          </TabPanel>

          {/* Bank Tab */}
          <TabPanel value={activeTab} index={2}>
            <List>
              <InfoItem
                icon={<AccountBalance />}
                label="Bank Name"
                value={userData?.bankName || "Not provided"}
              />
              <InfoItem
                icon={<Person />}
                label="Account Holder"
                value={userData?.accountHolderName || "Not provided"}
              />
              <InfoItem
                icon={<CreditCard />}
                label="Account Number"
                value={userData?.accountNumber ? `****${userData?.accountNumber?.toString().slice(-4)}` : "Not provided"}
              />
              <InfoItem
                icon={<Business />}
                label="IFSC Code"
                value={userData?.ifscCode || "Not provided"}
              />
              <InfoItem
                icon={<LocationOn />}
                label="Branch"
                value={userData?.branchName || "Not provided"}
              />
            </List>
            {editMode && (
              <Box sx={{ mt: 3 }}>
                <Button
                  variant="outlined"
                  startIcon={<Edit />}
                  sx={{ borderRadius: "12px" }}
                >
                  Edit Bank Details
                </Button>
              </Box>
            )}
          </TabPanel>

          {/* Subscription Tab */}
          <TabPanel value={activeTab} index={3}>
            <Paper
              sx={{
                p: 3,
                borderRadius: "16px",
                background: isDark
                  ? "linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)"
                  : "linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(29, 78, 216, 0.04) 100%)",
                border: `1px solid ${alpha(
                  isDark ? "#475569" : "#e2e8f0",
                  isDark ? 0.2 : 0.3
                )}`,
                mb: 3,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>
                  {userData?.softwareCost?.plan || "Pro"} Plan
                </Typography>
                {/* <Chip
                  label="Active"
                  color="success"
                  sx={{
                    fontWeight: 600,
                    background: isDark
                      ? "linear-gradient(135deg, rgba(34, 197, 94, 0.2) 0%, rgba(21, 128, 61, 0.2) 100%)"
                      : "linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(21, 128, 61, 0.15) 100%)",
                  }}
                /> */}
              </Box>

              <List>
                <InfoItem
                  icon={<CurrencyRupee />}
                  label="AMC"
                  value={userData?.amc}
                />
                <InfoItem
                  icon={<CalendarToday />}
                  label="Start Date"
                  value={userData?.startDate}
                />
                <InfoItem
                  icon={<CalendarToday />}
                  label="Expiry Date"
                  value={userData?.endDate}
                />
                {/* <InfoItem
                  icon={<CreditCard />}
                  label="Payment Method"
                  value={userData?.subscription?.paymentMethod}
                /> */}
                {/* <InfoItem
                  icon={<Refresh />}
                  label="Auto Renew"
                  value={userData?.subscription?.autoRenew ? "Enabled" : "Disabled"}
                  action={
                    <Switch
                      checked={userData?.subscription?.autoRenew}
                      color="primary"
                    />
                  }
                /> */}
              </List>

              {/* <Box sx={{ mt: 3 }}>
                <LinearProgress
                  variant="determinate"
                  value={75}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    mb: 1,
                    background: isDark
                      ? alpha("#475569", 0.3)
                      : alpha("#e2e8f0", 0.5),
                    "& .MuiLinearProgress-bar": {
                      background: isDark
                        ? "linear-gradient(90deg, #60A5FA 0%, #3B82F6 100%)"
                        : "linear-gradient(90deg, #2563EB 0%, #1D4ED8 100%)",
                      borderRadius: 4,
                    },
                  }}
                />
                <Typography variant="caption" sx={{ color: isDark ? "#94a3b8" : "#64748b" }}>
                  75% of subscription period completed
                </Typography>
              </Box> */}

              {/* <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
                <Button
                  variant="outlined"
                  startIcon={<Info />}
                  sx={{ borderRadius: "12px" }}
                >
                  Plan Details
                </Button>
                <Button
                  variant="contained"
                  startIcon={<CreditCard />}
                  sx={{
                    borderRadius: "12px",
                    background: isDark
                      ? "linear-gradient(135deg, #60A5FA 0%, #3B82F6 100%)"
                      : "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
                  }}
                >
                  Upgrade Plan
                </Button>
              </Box> */}
            </Paper>
          </TabPanel>

          {/* Settings Tab */}
<TabPanel value={activeTab} index={4}>
  <Paper
    sx={{
      p: 4,
      borderRadius: "16px",
      background: isDark
        ? "linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.8) 100%)"
        : "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.9) 100%)",
      border: `1px solid ${alpha(
        isDark ? "#475569" : "#e2e8f0",
        isDark ? 0.2 : 0.3
      )}`,
    }}
  >
    {/* Header */}
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        mb: 1,
        color: isDark ? "#f1f5f9" : "#1e293b",
      }}
    >
      Data Backup
    </Typography>

    {/* Description */}
    <Typography
      variant="body2"
      sx={{
        color: isDark ? "#94a3b8" : "#64748b",
        mb: 3,
        maxWidth: 500,
      }}
    >
      Backup all your business data including customers, invoices, products,
      and transactions. Export your data securely to an Excel file for
      safekeeping or migration.
    </Typography>

    {/* Export Button */}
    <Button
  variant="contained"
  onClick={handleExport}
  disabled={exporting}
  startIcon={
    exporting ? (
      <CircularProgress size={18} color="inherit" />
    ) : (
      <GetAppIcon />
    )
  }
  sx={{
    borderRadius: "12px",
    fontWeight: 600,
    px: 4,
    py: 1.5,
    background:
      "linear-gradient(135deg, #10B981 0%, #059669 100%)",
  }}
>
  {exporting ? "Exporting..." : "Export to Excel"}
</Button>
{exportMessage && (
  <Typography
    sx={{
      mt: 2,
      color: "#10B981",
      fontWeight: 500
    }}
  >
    {exportMessage}
  </Typography>
)}
  </Paper>
</TabPanel>

          {/* Security Tab */}
          {/* <TabPanel value={activeTab} index={4}>
            <List>
              <InfoItem
                icon={<Password />}
                label="Password"
                value="Last changed 15 days ago"
                action={
                  <Button
                    variant="outlined"
                    startIcon={<Lock />}
                    size="small"
                    onClick={() => setPasswordDialog(true)}
                    sx={{ borderRadius: "8px" }}
                  >
                    Change
                  </Button>
                }
              />
              <InfoItem
                icon={<Security />}
                label="Two-Factor Authentication"
                value="Not enabled"
                action={
                  <Switch color="primary" />
                }
              />
              <InfoItem
                icon={<Devices />}
                label="Active Sessions"
                value="2 devices"
                action={
                  <Button
                    variant="text"
                    size="small"
                    sx={{ borderRadius: "8px" }}
                  >
                    Manage
                  </Button>
                }
              />
              <InfoItem
                icon={<History />}
                label="Login History"
                value="Last login: Today, 09:30 AM"
                action={
                  <Button
                    variant="text"
                    size="small"
                    sx={{ borderRadius: "8px" }}
                  >
                    View All
                  </Button>
                }
              />
            </List>

            <Box sx={{ mt: 4, p: 3, borderRadius: "12px", background: isDark ? alpha("#1e293b", 0.3) : alpha("#f8fafc", 0.8) }}>
              <Typography variant="h6" sx={{ mb: 2, color: isDark ? "#f1f5f9" : "#1e293b" }}>
                Security Tips
              </Typography>
              <ul style={{ color: isDark ? "#94a3b8" : "#64748b", paddingLeft: 20 }}>
                <li>Use a strong, unique password</li>
                <li>Enable two-factor authentication</li>
                <li>Regularly review active sessions</li>
                <li>Log out from unused devices</li>
                <li>Keep your recovery email updated</li>
              </ul>
            </Box>
          </TabPanel> */}

          {/* Settings Tab */}
          {/* <TabPanel value={activeTab} index={4}>
            <List>
              <InfoItem
                icon={isDark ? <DarkMode /> : <LightMode />}
                label="Theme"
                value={isDark ? "Dark Mode" : "Light Mode"}
                action={
                  <Switch
                    checked={isDark}
                    onChange={() => { 
                      setIsDark(!isDark); 
                      localStorage.setItem('preferredTheme', !isDark ? 'dark' : 'light');
                     }}
                    color="primary"
                  />
                }
              />
              <InfoItem
                icon={<Notifications />}
                label="Notifications"
                value={userData?.settings?.notifications ? "Enabled" : "Disabled"}
                action={
                  <Switch
                    checked={userData?.settings?.notifications}
                    color="primary"
                  />
                }
              />
              <InfoItem
                icon={<Backup />}
                label="Auto Backup"
                value={`${userData?.settings?.autoBackup ? "Enabled" : "Disabled"} (${userData?.settings?.backupFrequency})`}
                action={
                  <Switch
                    checked={userData?.settings?.autoBackup}
                    color="primary"
                  />
                }
              />
              <InfoItem
                icon={<Language />}
                label="Language"
                value={userData?.settings?.language}
                action={
                  <Button
                    variant="text"
                    size="small"
                    sx={{ borderRadius: "8px" }}
                  >
                    Change
                  </Button>
                }
              />
              <InfoItem
                icon={<AccessTime />}
                label="Timezone"
                value={userData?.settings?.timezone}
                action={
                  <Button
                    variant="text"
                    size="small"
                    sx={{ borderRadius: "8px" }}
                  >
                    Change
                  </Button>
                }
              />
            </List>

            <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                startIcon={<Backup />}
                onClick={() => setBackupDialog(true)}
                sx={{ borderRadius: "12px" }}
              >
                Create Backup
              </Button>
              <Button
                variant="outlined"
                startIcon={<Download />}
                sx={{ borderRadius: "12px" }}
              >
                Export Data
              </Button>
              <Button
                variant="outlined"
                color="error"
                startIcon={<Delete />}
                sx={{ borderRadius: "12px" }}
              >
                Delete Account
              </Button>
            </Box>
          </TabPanel> */}
        </Paper>

        {/* Storage Usage */}
        {/* <Paper
          sx={{
            mt: 4,
            p: 3,
            borderRadius: "20px",
            background: isDark
              ? "linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.8) 100%)"
              : "linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(248, 250, 252, 0.8) 100%)",
            backdropFilter: "blur(20px)",
            border: `1px solid ${alpha(
              isDark ? "#475569" : "#e2e8f0",
              isDark ? 0.2 : 0.3
            )}`,
          }}
        >
          <Typography variant="h5" sx={{ mb: 3, fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>
            Storage Usage
          </Typography>
          
          <Box sx={{ mb: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography variant="body2" sx={{ color: isDark ? "#94a3b8" : "#64748b" }}>
                Used: {userData.stats.storageUsed}
              </Typography>
              <Typography variant="body2" sx={{ color: isDark ? "#94a3b8" : "#64748b" }}>
                Free: 35%
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={parseInt(userData.stats.storageUsed)}
              sx={{
                height: 10,
                borderRadius: 5,
                background: isDark
                  ? alpha("#475569", 0.3)
                  : alpha("#e2e8f0", 0.5),
                "& .MuiLinearProgress-bar": {
                  background: isDark
                    ? "linear-gradient(90deg, #60A5FA 0%, #3B82F6 100%)"
                    : "linear-gradient(90deg, #2563EB 0%, #1D4ED8 100%)",
                  borderRadius: 5,
                },
              }}
            />
          </Box>
          
          <Typography variant="caption" sx={{ color: isDark ? "#94a3b8" : "#64748b" }}>
            Last backup: {userData.stats.lastBackup}
          </Typography>
        </Paper> */}
      </Container>
    </Box>
  );
};

export default Profile;